import React, { memo, useState, useEffect, Fragment } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, TableContainer, Checkbox } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold'
  }
});

export default function ModalContactSep(props) {
  const ContactSep = props.model;
  const { contact } = props;
  const classes = useStyles();
  const [selectedContacts, setSelectedContacts] = useState([]);

  const IdContacto = contact.map((c) => c.number?.id);
  const unselectedContacts = IdContacto.filter((id) => !selectedContacts.includes(id));

  const handleToggleContact = (id) => {
    setSelectedContacts((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  useEffect(() => {
    if (ContactSep?.include) {
      // const preselected = ContactSep.include.map((i) => i.file_number_report_id);
      const preselected = ContactSep.include.map((i) => parseInt(i.number_report_id));
      setSelectedContacts(preselected);
    }
  }, [ContactSep]);


  return (
    <Modal
      title="Excluir Contactos de la hoja"
      model={ContactSep}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="report/detail-include"
      dataForce={{
        file_detail_report_id: ContactSep.id,
        included_contacts: selectedContacts,
        excluded_contacts: unselectedContacts,
      }}
    >
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="tabla de productos">
          <TableHead>
            <TableRow>
              <TableCell>Incluir</TableCell>
              <TableCell>Id Grupo</TableCell>
              <TableCell>Nombre Grupo o Contacto</TableCell>
              <TableCell>Telefono</TableCell>
              <TableCell>Zona</TableCell>
              <TableCell>Mesa</TableCell>
              <TableCell>Estado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contact.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No se encontraron contactos.
                </TableCell>
              </TableRow>
            )}

            {contact.map((p) => (
              <TableRow
                key={p.id}
              >
                <TableCell>
                  <Checkbox
                    checked={selectedContacts.includes(p.number?.id)}
                    onChange={() => handleToggleContact(p.number?.id)}
                    color="primary"
                  />
                </TableCell>
                <TableCell>{p.number?.description}</TableCell>
                <TableCell>{p.number?.grupo_description}</TableCell>
                <TableCell>{p.number?.phone}</TableCell>
                <TableCell>{p.number?.zone?.description}</TableCell>
                <TableCell>{p.number?.bureau?.description}</TableCell>
                <TableCell>{p.state}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Modal>
  );
}

